// extracted by mini-css-extract-plugin
module.exports = {"attributeChipContainer":"az_H3c","chip":"az_I3c","chipValue":"az_J3c","chipLabel":"az_K3c"};